import type { ButtonProps } from './Button';
import type { Ref } from 'react';

import { forwardRef } from 'react';
import { css, styled } from 'styled-components';

import { ButtonContent, DefaultButtonSC } from './Button';

type Props = ButtonProps & {
  colorVariant?: 'green' | 'aqua';
};

export const primaryButtonColorsGreen = css`
  background: ${(props) => props.theme.colors.emeraldGreen[100]};
  border-color: ${(props) => props.theme.colors.emeraldGreen[100]};
  color: ${(props) => props.theme.colors.white};

  &:hover {
    background: ${(props) => props.theme.colors.emeraldGreen[80]};
  }

  &:active {
    background: ${(props) => props.theme.colors.emeraldGreen[100]};
    color: ${(props) => props.theme.colors.shadows.white[80]};
  }

  &[disabled],
  &:disabled {
    background: ${(props) => props.theme.colors.shadows.oxfordBlue[30]};
    border-color: ${(props) => props.theme.colors.shadows.oxfordBlue[30]};
    color: ${(props) => props.theme.colors.shadows.oxfordBlue[80]};
  }
`;

export const primaryButtonColorsAqua = css`
  background: ${(props) => props.theme.colors.tiffanyGreen[100]};
  border-color: ${(props) => props.theme.colors.tiffanyGreen[100]};
  color: ${(props) => props.theme.colors.white};

  &:hover {
    background: ${(props) => props.theme.colors.tiffanyGreen[50]};
  }

  &:active {
    background: ${(props) => props.theme.colors.tiffanyGreen[100]};
    color: ${(props) => props.theme.colors.shadows.white[80]};
  }

  &[disabled],
  &:disabled {
    background: ${(props) => props.theme.colors.shadows.oxfordBlue[30]};
    border-color: ${(props) => props.theme.colors.shadows.oxfordBlue[30]};
    color: ${(props) => props.theme.colors.shadows.oxfordBlue[80]};
  }
`;

const PrimaryButtonSC = styled(DefaultButtonSC)<{ $colorVariant?: 'green' | 'aqua' }>`
  ${(props) => {
    switch (props.$colorVariant) {
      case 'aqua':
        return primaryButtonColorsAqua;
      default:
        return primaryButtonColorsGreen;
    }
  }}
  border-radius: 1.625rem;
  box-shadow: 0px 3px 8px ${(props) => props.theme.colors.shadows.emeraldGreen[20]};
`;

export const PrimaryButton = forwardRef(
  ({ children, colorVariant, leftIcon, rightIcon, size, ...props }: Props, ref: Ref<HTMLButtonElement>) => {
    return (
      <PrimaryButtonSC ref={ref} $colorVariant={colorVariant} $size={size} {...props}>
        <ButtonContent leftIcon={leftIcon} rightIcon={rightIcon}>
          {children}
        </ButtonContent>
      </PrimaryButtonSC>
    );
  },
);
